<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="group-list-content-loading" class="vs-con-loading__container">
		<div v-if="navbarOptions" class="vx-row mb-2">
			<div class="vx-col md:w-full">
				<label class="g-table--title" v-text="$t('Groups.AssignedGroups')"></label>
			</div>
		</div>
		<div class="vx-row flex items-center">
			<div v-if="navbarOptions" class="vx-col md:w-1/5 mt-2">
				<div class="o-span--count bg-primary" v-text="assignedGroups.length"></div>
			</div>
			<div v-if="navbarOptions" class="vx-col md:w-3/5 mt-2">
				<vs-button
					type="border"
					color="#F9841E"
					style="padding: 0.3rem 2.5rem; font-size: 12px; line-height: 15px"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="groupMounted = true"
					>{{ $t("ButtonAddTypeConfig") }}
				</vs-button>
			</div>
			<div v-if="navbarOptions" class="vx-col md:w-1/5 flex justify-end mt-2">
				<vx-tooltip
					v-if="assignedGroups.length > 1"
					class="cursor-pointer mr-4"
					color="primary"
					position="bottom"
					:title="$t('Crud.Delete')"
					:text="$t('Groups.DeleteAllGroups')"
				>
					<feather-icon
						class="g-label--normal"
						size="small"
						icon="TrashIcon"
						svgClasses="h-5 w-5 text-danger cursor-pointer"
						@click.stop="openDeleteAllConfirm"
					/>
				</vx-tooltip>
				<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
					<feather-icon
						id="btn-show-list-resources"
						class="g-label--normal"
						size="small"
						icon="LayoutIcon"
						svgClasses="h-5 w-5 text-dark cursor-pointer"
					/>
					<vs-dropdown-menu style="width: 30%">
						<vx-card no-shadow :title="$t('VisitPointObject.Columns')">
							<p>{{ $t("VisitPointObject.ColumnsText") }}</p>
							<ul class="demo-alignment">
								<li>
									<vs-checkbox v-model="checkBoxID">ID</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxName">{{ $t("Name") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxDescription">{{ $t("Description") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxAddress">{{ $t("Address") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxInitHour">{{ $t("InitHour") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxEndHour">{{ $t("EndHour") }}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxResources"
										>{{ $t("Resource.Resources") }}
									</vs-checkbox>
								</li>
							</ul>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<vue-perfect-scrollbar class="scroll-group-area" :settings="settings">
				<hr v-if="navbarOptions" class="mt-3" style="border: 0.75px solid #a3a3a3" />
				<vs-table
					v-if="assignedGroups.length > 0"
					ref="table"
					search
					pagination
					max-items="5"
					:data="assignedGroups"
				>
					<div
						v-if="!navbarOptions"
						slot="header"
						class="flex flex-wrap-reverse items-center flex-grow justify-between"
					>
						<div class="flex items-center">
							<label class="g-table--title mr-2 ml-6" v-text="$t('Groups.TotalGroups')"></label>
							<div class="o-span--count bg-primary" v-text="assignedGroups.length"></div>
						</div>
					</div>
					<template slot="thead">
						<vs-th class="g-table--title" v-show="enableHeadTable('action')"></vs-th>
						<vs-th class="g-table--title" sort-key="name" v-show="enableHeadTable('id') && checkBoxID">
							ID
						</vs-th>
						<vs-th class="g-table--title" sort-key="name" v-show="enableHeadTable('name') && checkBoxName">
							{{ $t("Name") }}
						</vs-th>
						<vs-th
							class="g-table--title"
							sort-key="description"
							v-show="enableHeadTable('description') && checkBoxDescription"
							>{{ $t("Description") }}
						</vs-th>
						<vs-th
							class="g-table--title"
							sort-key="address"
							v-show="enableHeadTable('address') && checkBoxAddress"
							>{{ $t("Address") }}
						</vs-th>
						<vs-th
							class="g-table--title"
							sort-key="hour_init"
							v-show="enableHeadTable('hour_init') && checkBoxInitHour"
							>{{ $t("InitHour") }}
						</vs-th>
						<vs-th
							class="g-table--title"
							sort-key="hour_end"
							v-show="enableHeadTable('hour_end') && checkBoxEndHour"
							>{{ $t("EndHour") }}
						</vs-th>
						<vs-th
							class="g-table--title"
							sort-key="hour_end"
							v-show="enableHeadTable('total_resource') && checkBoxResources"
							>{{ $t("Resource.Resources") }}
						</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td
									class="g-table--description whitespace-no-wrap"
									v-show="enableHeadTable('action')"
								>
									<feather-icon
										icon="Trash2Icon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="g-label--normal ml-2"
										@click.stop="removeAssignedGroup(tr.id)"
									/>
								</vs-td>
								<vs-td v-show="enableHeadTable('id') && checkBoxID">
									<p class="g-table--description">{{ tr.id }}</p>
								</vs-td>
								<vs-td v-show="enableHeadTable('name') && checkBoxName">
									<p class="g-table--description">{{ tr.name }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('description') && checkBoxDescription">
									<p class="g-table--description">{{ tr.description | title }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('address') && checkBoxAddress">
									<p class="g-table--description">{{ tr.address | title }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('hour_init') && checkBoxInitHour">
									<p class="g-table--description">{{ tr.hour_init }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('hour_end') && checkBoxEndHour">
									<p class="g-table--description">{{ tr.hour_end }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('total_resource') && checkBoxResources">
									<p class="g-table--description">{{ tr.total_resource }}</p>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else class="g-label--normal text-center mt-2" v-text="$t('Groups.NoAssignedGroups')"></p>
				<slot name="alert-message"> </slot>
			</vue-perfect-scrollbar>
		</div>
		<vs-popup class="vs-popup--content-custom" :fullscreen="false" :title="null" :active.sync="groupMounted">
			<bread-crumbs
				:title="$t('Groups.AssignGroups')"
				:subTitle="$t('general.SubtitleGroups')"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<group-list v-if="groupMounted" :customConfig="groupListConfig" @showPopupEmmit="showPopupGroup" />
		</vs-popup>
	</div>
</template>

<script>
import moduleGroup from "@/store/group/moduleGroup.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import GroupList from "@/components/group/GroupListView.vue";
import PopupCustomize from "../../core/components/PopupCustomize";

export default {
	components: {
		PopupCustomize,
		VuePerfectScrollbar,
		GroupList,
	},
	props: {
		columns: {
			type: Array,
			default: () => [
				"id",
				"name",
				"description",
				"address",
				"hour_init",
				"hour_end",
				"total_resource",
				"action",
			],
		},
		defaultColumns: {
			type: Array,
			default: () => [
				"id",
				"name",
				"description",
				"address",
				"hour_init",
				"hour_end",
				"total_resource",
				"action",
			],
		},
		navbarOptions: {
			type: Boolean,
			default: true,
		},
		multiple: {
			type: Boolean,
			default: true,
		},
		groupListIds: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			activeItem: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			groupMounted: false,
			itemsPerPage: 10,
			isMounted: false,
			groupListConfig: {
				columns: ["name", "hour_init", "hour_end"],
				actionDropdown: false,
				btnAssigGroup: true,
				rowSelectionMultiple: this.multiple,
			},
			checkBoxName: true,
			checkBoxDescription: true,
			checkBoxAddress: true,
			checkBoxInitHour: true,
			checkBoxEndHour: true,
			checkBoxID: true,
			checkBoxResources: true,
		};
	},
	computed: {
		assignedGroups() {
			return this.$store.state.moduleGroup.groupsActivity;
		},
		groupUpdatePermission() {
			return this.$store.getters.checkPermission("GROUPS_U");
		},
		groupDeletePermission() {
			return this.$store.getters.checkPermission("GROUPS_D");
		},
		enableHeadTable() {
			return (headName) => this.columns.includes(headName);
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		async getAssignedGroups() {
			let payload = {
				ids: this.groupListIds || [],
				fields: ["id", "name", "description", "address", "dirtrad", "hour_init", "hour_end"],
			};
			try {
				this.openLoadingContent("#group-list-content-loading");
				await this.$store.dispatch("moduleGroup/getGroupsByFilter", payload);
				this.closeLoadingContent("#group-list-content-loading");
			} catch (error) {
				this.closeLoadingContent("#group-list-content-loading");
			}
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${this.$t("Groups.AssignedGroups")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleGroup/CLEAN_GROUP_ACTIVITY");
		},
		showPopupGroup(val) {
			this.groupMounted = val;
		},
		removeAssignedGroup(id) {
			this.$store.dispatch("moduleGroup/removeGroupActivity", id);
		},
	},
	created() {
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		this.checkBoxDescription = this.defaultColumns.includes("description");
		this.checkBoxAddress = this.defaultColumns.includes("address");
		this.checkBoxInitHour = this.defaultColumns.includes("hour_init");
		this.checkBoxEndHour = this.defaultColumns.includes("hour_end");
		this.checkBoxID = this.defaultColumns.includes("id");
		this.checkBoxResources = this.defaultColumns.includes("total_resource");
	},
	mounted() {
		this.isMounted = true;
		if (this.groupListIds && this.groupListIds.length > 0) {
			this.getAssignedGroups(this.groupListIds);
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleGroup/CLEAN_GROUP_ACTIVITY");
	},
};
</script>

<style lang="scss" scoped>
.scroll-group-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 450px;
}
</style>
